module.exports = __webpack_public_path__ + "static/messenger-privacy-settings-a9bbc85ccc543a67a5f238323ddbeae9.png";